import { IBestPriceBagItem } from '@/modules/mixing/store/analytical-mixing.store';
import classNames from 'classnames';
import styles from './index.module.sass';

export const MainInfo = ({
  className,
  data,
  id,
  isStationary,
}: {
  className?: string;
  data: IBestPriceBagItem;
  id: string;
  isStationary: boolean;
}) => {
  return (
    <div className={classNames(styles.mainInfo, className)}>
      <div className={styles.row}>
        <span className={styles.label}>{isStationary ? 'id объема' : 'id рукава'}</span>
        <span className={styles.value}>{id}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>вес</span>
        <span className={styles.value}>{data.weight} т</span>
      </div>
    </div>
  );
};
